import { useState } from 'react';
import s from './WelcomeCarousel.module.css';

// A one-time, dismissible "here's how it works" shown the FIRST time someone enters a
// given league (SeasonHome tracks tpiap:welcomed:<leagueId> in localStorage). Content
// is tailored to how rounds are made (Jukebox = members propose; DJ = owner builds).

type Slide = { emoji: string; title: string; body: string };

function slidesFor(name: string, jukebox: boolean): Slide[] {
  return [
    { emoji: '🎵', title: `Welcome to ${name}`, body: 'This place is a playlist. Each round everyone drops one track on a theme — then you rank them, guess who submitted what, and talk trash.' },
    jukebox
      ? { emoji: '🎲', title: 'You pick the themes', body: 'In this league members propose round ideas, and they’re drawn into a running order at random. Tap “+ Propose” on the home screen to add yours.' }
      : { emoji: '🎧', title: 'The organiser builds rounds', body: 'Here the owner sets each round. When one opens you’ll get a nudge on the home screen to submit your track.' },
    { emoji: '🗳️', title: 'Play each round', body: 'Submit one track, spend your points to rank everyone else’s, guess who submitted each, and optionally veto one. Points, detective work, and staying hidden all score.' },
  ];
}

export function WelcomeCarousel({ name, jukebox, onClose }: { name: string; jukebox: boolean; onClose: () => void }) {
  const slides = slidesFor(name, jukebox);
  const [i, setI] = useState(0);
  const last = i === slides.length - 1;
  const slide = slides[i];
  return (
    <div className={s.overlay} role="dialog" aria-modal="true" aria-label="Welcome">
      <div className={s.card}>
        <button className={s.skip} onClick={onClose} aria-label="Skip">Skip</button>
        <div className={s.emoji} aria-hidden>{slide.emoji}</div>
        <h2 className={s.title}>{slide.title}</h2>
        <p className={s.body}>{slide.body}</p>
        <div className={s.dots}>
          {slides.map((_, n) => <span key={n} className={n === i ? s.doton : s.dot} />)}
        </div>
        <div className={s.foot}>
          {i > 0 ? <button className={s.back} onClick={() => setI(i - 1)}>Back</button> : <span />}
          <button className={s.next} onClick={() => (last ? onClose() : setI(i + 1))}>{last ? 'Let’s go →' : 'Next →'}</button>
        </div>
      </div>
    </div>
  );
}
